export const iconList = [
  'ai',
  'octagon',
  'home',
  'car',
  'cpu',
  'refresh',
  'bell',
  'brain',
  'folder',
  'eye-off',
  'help',
  'presentation',
  'film',
  'userplus',
  'eye',
  'component',
  'arrow-left',
  'search',
  'filter',
  'arrow-down',
  'chevron-down',
  'mic',
  'wind',
  'edit2',
  'edit',
  'more',
  'layout',
  'alert',
  'trash',
  'user',
  'email',
  'logout',
  'heart',
  'file',
  'close',
  'error',
  'settings',
  'box',
  'add',
  'info',
  'check-circle'
];
export const iconColors = [
  "neutral",
  "error",
  "success",
  "warning",
  "information",
  "brand"
]
